export enum ENotificationType {
  WORKFLOW_NOTIFICATION = 'WorkflowNotification',
  COMMENT_NOTIFICATION = 'CommentNotification',
  QUIZ_NOTIFICATION = 'QuizNotification',
  COURSE_NOTIFICATION = 'CourseNotification',
  UPDATED_COMMON_STEP_NOTIFICATION = 'UpdatedCommonStepNotification'
}

export enum EFirebasePermission {
  GRANTED = 'granted',
  DENIED = 'denied',
  DEFAULT = 'default'
}